import React from "react"

import { ProjectPDFOverlay } from "./ProjectPDFOverlay"
import { useProjectPDFOverlayModel } from "./hooks/useProjectPDFOverlayModel"

export interface ProjectPDFPayload {
  projectID: string
  isShareID?: boolean
}

export interface ProjectPDFOverlayConnectorProps {
  payload: ProjectPDFPayload
}

export const ProjectPDFOverlayConnector = React.memo(
  (props: ProjectPDFOverlayConnectorProps) => (
    <ProjectPDFOverlay {...useProjectPDFOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PROJECT_PDF_OVERLAY: ProjectPDFPayload
  }
}
